import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { SettingsToggleRow } from '@/features/account-information'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { selectIsDarkMode, setIsDarkMode } from '@/redux/ui/uiSlice'

/**
 * The same dark-mode control as Settings > Account Management, embedded in the
 * FTU modal body so the user can switch back to light mode without leaving the
 * callout.
 */
export const DarkModeFtuToggle = () => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const dispatch = useAppDispatch()
  const isDarkMode = useAppSelector(selectIsDarkMode)

  return (
    <SettingsToggleRow
      colorScheme={colorScheme}
      dataTestId='ftu-dark-mode-toggle'
      isOn={isDarkMode}
      label={t('first_time_use:dark_mode.toggle_label')}
      onChange={(nextIsOn) => dispatch(setIsDarkMode(nextIsOn))}
    />
  )
}
